import React from 'react';

interface IQRCode {
  dataId: string;
  imageSrc: string;
}
export const QRCode = ({ dataId, imageSrc }: IQRCode) => (
  <img data-id={dataId} src={imageSrc} width="176" height="176" alt="QR code for the Origin app" />
);
